import { Button, Grid, Modal } from "@mui/material";
import { FunctionComponent, useState } from "react";
import ContainerModal from "../../../../../components/modalExportar/components/containerModal";
import { SelectSede } from "../../../../../components/selects/sede";
import FilterListIcon from '@mui/icons-material/FilterList';
import { useServicesCRM } from "../../context/getCRM";

interface ModalFilterProps {

}

const ModalFilter: FunctionComponent<ModalFilterProps> = () => {


  const { getWithParams, alterParams, params, clearParams } = useServicesCRM()

  const [isOpen, setIsOpen] = useState(false);

  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (<>
    <Modal open={isOpen} onClose={onClose}>
      <ContainerModal>
        <Grid>
          <p></p>
        </Grid>
        <Grid>
          <SelectSede
            action={(event) => { alterParams(event) }}
            value={params?.idsede}
          />
        </Grid>
        <Grid display={'flex'} justifyContent={'space-between'} alignItems={'center'} mt={1}>
          <Button onClick={clearParams} color="error">Cancelar</Button>
          <Button onClick={getWithParams} variant="contained" sx={{ boxShadow: 'none' }}>Filtrar</Button>
        </Grid>
      </ContainerModal>
    </Modal>
    <Button sx={{ boxShadow: 'none' }}
      startIcon={<FilterListIcon />}
      variant='contained'
      onClick={onOpen}
      >
      Filtro
    </Button>

  </>);
}

export default ModalFilter;
